@if (showbrowser) {
  <div class="Broswer-testing">
    <div class="header">
    <div class="containerStats" style="color: #1f71ff;
    height: 100%;
    border-radius: 30px;
    background-image: radial-gradient(#1f71ff1a, white);" id="total">
        <div class="iconNumber">
          <i class="icon fa fa-globe visitors"></i>
          <span style="font-size: xxx-large;">{{totalNumber}}</span>
        </div>
        <div class="statusType">{{"TOTAL" | translate}}</div>
      </div>
    <div class="containerStats" style="color: #006900;
    height: 100%;
    border-radius: 30px;
    background-image: radial-gradient(#42cd001a, white);" id="usable">
        <div class="iconNumber">
          <i class="icon fa fa-check visitors"></i>
          <span style="font-size: xxx-large;">{{usableNumber}}</span>
        </div>
        <div class="statusType">{{"USABLE" | translate}}</div>
      </div>
    <div class="containerStats" style="color: #ff6296;
    height: 100%;
    background-image: radial-gradient(#ffc0cb4d, white);
    border-radius: 30px;" id="busy">
        <div class="iconNumber">
          <i class="icon fa fa-users visitors"></i>
          <span style="font-size: xxx-large;">{{busyNumber}}</span>
        </div>
        <div class="statusType">{{"BUSY" | translate}}</div>
      </div>
    <div class="containerStats" style="color: #d88c00;
    border-radius: 30px;
    height: 100%;
    background-image: radial-gradient(#ffa1012d, white);" id="email">
        <div class="iconNumber">
          <i class="icon fa fa-user visitors"></i>
        </div>
        <div class="statusType">{{userObj.mail}}</div>
      </div>
    </div>
    <div class="main">
      <div class="tabs">
        <div class="tab" [ngClass]="{'active': activeTab === 'windows'}" (click)="setActiveTab('windows')">
          <i class="fa fa-brands fa-windows" style="margin-right: 2px;"></i>
          <span>Windows</span>
        </div>
        <div class="tab" [ngClass]="{'active': activeTab === 'mac'}" (click)="setActiveTab('mac')">
          <i class="fa fa-brands fa-apple" style="margin-right: 2px;"></i>
          <span>Mac</span>
        </div>
        <div class="tab" [ngClass]="{'active': activeTab === 'linux'}" (click)="setActiveTab('linux')">
          <i class="fa fa-brands fa-linux" style="margin-right: 2px;"></i>
          <span>Linux</span>
        </div>
        <input class="search-input" placeholder="Search" type="search"  [(ngModel)]="searchText"
          (ngModelChange)="filterBrowserDetails()" >
      </div>
      <div class="tab-content" [ngClass]="{'hidden': activeTab !== 'mac'}">
        @if (!macBrowsers || macBrowsers.length === 0) {
          <div class="no-browsers-message">
            <div class="text-center" style="padding: 40px; color: #666;">
              <i class="fa fa-desktop" style="font-size: 48px; margin-bottom: 16px; opacity: 0.5;"></i>
              <p style="font-size: 18px; margin: 0;">{{"No browsers assigned to you for Mac" | translate}}</p>
            </div>
          </div>
        }
        @if (macBrowsers && macBrowsers.length > 0) {
          <div class="row">
            <div class="col-md-6">
              @for (item of macBrowsers.slice(0, math.ceil(macBrowsers.length / 2)); track trackByFn($index, item)) {
                <div>
                  <div class="clickableIcons">
                    <img class="browserIcons" [src]="item.img">
                    <div style="display: flex; flex-direction: column;"><strong>{{item.name}}</strong><small
                  style="font-size: xx-small;">{{item.automationUrl}}</small></div>
                  <span style="font-size: 12px;">
                    <strong>{{"Status:" | translate}}</strong>
                    {{item.user == null ? 'Available' :
                    (item.user === userObj.mail ? 'Connected (You)' :
                    'Busy(' + item.user + ')')}}
                  </span>
                  @if (item.user == null) {
                    <button (click)="Launch(item)" class="btn btn-sm btn-primary">
                      {{"Connect" | translate}}
                    </button>
                  }
                  @if (item.user === userObj.mail) {
                    <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                      {{"Disconnect" | translate}}
                    </button>
                  }
                  @if (item.user != null && item.user !== userObj.mail && Loginprivilege === 'admin') {
                    <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                      {{"Disconnect" | translate}}
                    </button>
                  }
                  @if (item.user != null && item.user !== userObj.mail && Loginprivilege !== 'admin') {
                    <button [disabled]="true" class="btn btn-sm btn-primary">
                      {{"Connect" | translate}}
                    </button>
                  }
                </div>
              </div>
            }
          </div>
          <!-- Right Column -->
          <div class="col-md-6">
            @for (item of macBrowsers.slice(math.ceil(macBrowsers.length / 2)); track trackByFn($index, item)) {
              <div>
                <div class="clickableIcons">
                  <img class="browserIcons" [src]="item.img">
                  <div style="display: flex; flex-direction: column;"><strong>{{item.name}}</strong><small
                style="font-size: xx-small;">{{item.automationUrl}}</small></div>
                <span style="font-size: 12px;">
                  <strong>{{"Status:" | translate}}</strong>
                  {{item.user == null ? 'Available' :
                  (item.user === userObj.mail ? 'Connected (You)' :
                  'Busy(' + item.user + ')')}}
                </span>
                @if (item.user == null) {
                  <button (click)="Launch(item)" class="btn btn-sm btn-primary">
                    {{"Connect" | translate}}
                  </button>
                }
                @if (item.user === userObj.mail) {
                  <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                    {{"Disconnect" | translate}}
                  </button>
                }
                @if (item.user != null && item.user !== userObj.mail && Loginprivilege === 'admin') {
                  <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                    {{"Disconnect" | translate}}
                  </button>
                }
                @if (item.user != null && item.user !== userObj.mail && Loginprivilege !== 'admin') {
                  <button [disabled]="true" class="btn btn-sm btn-primary">
                    {{"Connect" | translate}}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <!-- LINUX TAB CONTENT -->
  <div class="tab-content" [ngClass]="{'hidden': activeTab !== 'linux'}">
    <!-- Show message when no Linux browsers are available -->
    @if (!linuxBrowsers || linuxBrowsers.length === 0) {
      <div class="no-browsers-message">
        <div class="text-center" style="padding: 40px; color: #666;">
          <i class="fa fa-desktop" style="font-size: 48px; margin-bottom: 16px; opacity: 0.5;"></i>
          <p style="font-size: 18px; margin: 0;">{{"No browsers assigned to you for Linux" | translate}}</p>
        </div>
      </div>
    }
    <!-- Show browsers when available -->
    @if (linuxBrowsers && linuxBrowsers.length > 0) {
      <div class="row">
        <div class="col-md-6">
          @for (item of linuxBrowsers.slice(0, math.ceil(linuxBrowsers.length / 2)); track trackByFn($index, item)) {
            <div>
              <div class="clickableIcons">
                <img class="browserIcons" [src]="item.img">
                <div style="display: flex; flex-direction: column;"><strong>{{item.name}}</strong><small
              style="font-size: xx-small;">{{item.automationUrl}}</small></div>
              <span style="font-size: 12px;">
                <strong>{{"Status:" | translate}}</strong>
                {{item.user == null ? 'Available' :
                (item.user === userObj.mail ? 'Connected (You)' :
                'Busy(' + item.user + ')')}}
              </span>
              @if (item.user == null) {
                <button (click)="Launch(item)" class="btn btn-sm btn-primary">
                  {{"Connect" | translate}}
                </button>
              }
              @if (item.user === userObj.mail) {
                <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                  {{"Disconnect" | translate}}
                </button>
              }
              @if (item.user != null && item.user !== userObj.mail && Loginprivilege === 'admin') {
                <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                  {{"Disconnect" | translate}}
                </button>
              }
              @if (item.user != null && item.user !== userObj.mail && Loginprivilege !== 'admin') {
                <button [disabled]="true" class="btn btn-sm btn-primary">
                  {{"Connect" | translate}}
                </button>
              }
            </div>
          </div>
        }
      </div>
      <div class="col-md-6">
        @for (item of linuxBrowsers.slice(math.ceil(linuxBrowsers.length / 2)); track trackByFn($index, item)) {
          <div>
            <div class="clickableIcons">
              <img class="browserIcons" [src]="item.img">
              <div style="display: flex; flex-direction: column;"><strong>{{item.name}}</strong><small
            style="font-size: xx-small;">{{item.automationUrl}}</small></div>
            <span style="font-size: 12px;">
              <strong>{{"Status:" | translate}}</strong>
              {{item.user == null ? 'Available' :
              (item.user === userObj.mail ? 'Connected (You)' :
              'Busy(' + item.user + ')')}}
            </span>
            @if (item.user == null) {
              <button (click)="Launch(item)" class="btn btn-sm btn-primary">
                {{"Connect" | translate}}
              </button>
            }
            @if (item.user === userObj.mail) {
              <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                {{"Disconnect" | translate}}
              </button>
            }
            @if (item.user != null && item.user !== userObj.mail && Loginprivilege === 'admin') {
              <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                {{"Disconnect" | translate}}
              </button>
            }
            @if (item.user != null && item.user !== userObj.mail && Loginprivilege !== 'admin') {
              <button [disabled]="true" class="btn btn-sm btn-primary">
                {{"Connect" | translate}}
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
</div>
<div class="tab-content" [ngClass]="{'hidden': activeTab !== 'windows'}">
  @if (!windowsBrowsers || windowsBrowsers.length === 0) {
    <div class="no-browsers-message">
      <div class="text-center" style="padding: 40px; color: #666;">
        <i class="fa fa-desktop" style="font-size: 48px; margin-bottom: 16px; opacity: 0.5;"></i>
        <p style="font-size: 18px; margin: 0;">{{"No browsers assigned to you for Windows" | translate}}</p>
      </div>
    </div>
  }
  @if (windowsBrowsers && windowsBrowsers.length > 0) {
    <div class="row">
      <div class="col-md-6">
        @for (item of windowsBrowsers.slice(0, math.ceil(windowsBrowsers.length / 2)); track trackByFn($index, item)) {
          <div>
            <div class="clickableIcons">
              <img class="browserIcons" [src]="item.img">
              <div style="display: flex; flex-direction: column;"><strong>{{item.name}}</strong><small
            style="font-size: xx-small;">{{item.automationUrl}}</small></div>
            <span style="font-size: 12px;">
              <strong>{{"Status:" | translate}}</strong>
              {{item.user == null ? 'Available' :
              (item.user === userObj.mail ? 'Connected (You)' :
              'Busy(' + item.user + ')')}}
            </span>
            @if (item.user == null) {
              <button (click)="Launch(item)" class="btn btn-sm btn-primary">
                {{"Connect" | translate}}
              </button>
            }
            @if (item.user === userObj.mail) {
              <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                {{"Disconnect" | translate}}
              </button>
            }
            @if (item.user != null && item.user !== userObj.mail && Loginprivilege === 'admin') {
              <!-- Admin viewing other user's browser - show Disconnect button -->
              <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
                {{"Disconnect" | translate}}
              </button>
            }
            @if (item.user != null && item.user !== userObj.mail && Loginprivilege !== 'admin') {
              <button [disabled]="true" class="btn btn-sm btn-primary">
                {{"Connect" | translate}}
              </button>
            }
          </div>
        </div>
      }
    </div>
    <div class="col-md-6">
      @for (item of windowsBrowsers.slice(math.ceil(windowsBrowsers.length / 2)); track trackByFn($index, item)) {
        <div>
          <div class="clickableIcons">
            <img class="browserIcons" [src]="item.img">
            <div style="display: flex; flex-direction: column;"><strong>{{item.name}}</strong><small
          style="font-size: xx-small;">{{item.automationUrl}}</small></div>
          <span style="font-size: 12px;">
            <strong>{{"Status:" | translate}}</strong>
            {{item.user == null ? 'Available' :
            (item.user === userObj.mail ? 'Connected (You)' :
            'Busy(' + item.user + ')')}}
          </span>
          @if (item.user == null) {
            <button (click)="Launch(item)" class="btn btn-sm btn-primary">
              {{"Connect" | translate}}
            </button>
          }
          @if (item.user === userObj.mail) {
            <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
              {{"Disconnect" | translate}}
            </button>
          }
          @if (item.user != null && item.user !== userObj.mail && Loginprivilege === 'admin') {
            <button (click)="disconnectBrowser(item)" class="btn btn-sm btn-danger">
              {{"Disconnect" | translate}}
            </button>
          }
          @if (item.user != null && item.user !== userObj.mail && Loginprivilege !== 'admin') {
            <button [disabled]="true" class="btn btn-sm btn-primary">
              {{"Connect" | translate}}
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
}
</div>
</div>
</div>
}

<ng-template #alerttemplate let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>